/**
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

export default {
  quickviewOpened: 'quickviewOpened',
  clickQuickview: 'clickQuickview',
  handleError: 'handleError',
  responsiveUpdate: 'responsiveUpdate',
  updateCart: 'updateCart',
  updatedCart: 'updatedCart',
  updateProductList: 'updateProductList',
  updateProduct: 'updateProduct',
  updatedProduct: 'updatedProduct',
  updateFacets: 'updateFacets',
};
